<template>
  <span
    v-if="productViewsCount && productViewsCount.count > 2"
    class="text-gray-500 flex items-center text-sm"
  >
    <IconUsers class="mr-2 size-6 text-gold" />
    <span>
      {{ $t('pdp.motivation_layer.product_views_prefix') }}
      <span class="text-lg font-bold text-gold">{{
        productViewsCount.count
      }}</span>
      {{ $t('pdp.motivation_layer.product_views_suffix') }}
    </span>
  </span>
  <span
    v-if="purchases && purchases > 2"
    class="text-gray-500 flex items-center text-sm"
  >
    <IconShoppingCartFill class="mr-2 size-6 text-gold" />
    <span>
      {{ $t('pdp.motivation_layer.product_purchases_prefix') }}
      <span class="text-lg font-bold text-gold">{{ purchases }}</span>
      {{ $t('pdp.motivation_layer.product_purchases_suffix') }}
    </span>
  </span>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { Product } from '@scayle/storefront-nuxt'
import useProductViewCounter from '~/composables/useProductViewCounter'
import useProductPurchases from '~/composables/useProductPurchases'

const props = defineProps<{
  product: Product
}>()

const productId = computed(() => props.product.id)

const { data: productViewsCount } = useProductViewCounter(productId)
const { purchases } = useProductPurchases(productId)
</script>
